import { createSlice } from '@reduxjs/toolkit'
import { create } from '@bufbuild/protobuf'

import { Person, PersonSchema } from '@/api/form/v1/form_pb'

const newPerson: Person = create(PersonSchema, {
	id: '',
	gender: '',
	lastName: '',
	firstName: '',
	phone: '',
	email: '',
	birthDate: '',
	birthCity: '',
	birthCountry: '',
	nationality: '',
	profession: '',
	address: '',
	married: '',
	children: '',
	marriageCity: '',
	marriageDate: '',
	hasContract: '',
	contractDate: '',
	contractPlace: '',
	contractType: '',
	idFile: '',
	nonFinancingDeclarationFile: '',
})

type PersonState = {
	persons: Person[]
}

const initialState: PersonState = {
	persons: [],
}

export const personSlice = createSlice({
	name: 'Person',
	initialState,
	reducers: {
		resetPersons: state => {
			state.persons = []
		},
		addPerson: (state, action) => {
			const person = { ...newPerson, id: action.payload }
			state.persons.push(person)
		},
		removePerson: (state, action) => {
			const index = state.persons.findIndex(person => person.id === action.payload)
			if (index !== -1) {
				state.persons.splice(index, 1)
			}
		},
		setGender: (state, action) => {
			state.persons.find(person => action.payload.id === person.id)!.gender = action.payload.value
		},
		setLastName: (state, action) => {
			state.persons.find(person => action.payload.id === person.id)!.lastName = action.payload.value
		},
		setFirstName: (state, action) => {
			state.persons.find(person => action.payload.id === person.id)!.firstName =
				action.payload.value
		},
		setPhone: (state, action) => {
			state.persons.find(person => action.payload.id === person.id)!.phone = action.payload.value
		},
		setEmail: (state, action) => {
			state.persons.find(person => action.payload.id === person.id)!.email = action.payload.value
		},
		setBirthDate: (state, action) => {
			state.persons.find(person => action.payload.id === person.id)!.birthDate =
				action.payload.value
		},
		setBirthCity: (state, action) => {
			state.persons.find(person => action.payload.id === person.id)!.birthCity =
				action.payload.value
		},
		setBirthCountry: (state, action) => {
			state.persons.find(person => action.payload.id === person.id)!.birthCountry =
				action.payload.value
		},
		setNationality: (state, action) => {
			state.persons.find(person => action.payload.id === person.id)!.nationality =
				action.payload.value
		},
		setProfession: (state, action) => {
			state.persons.find(person => action.payload.id === person.id)!.profession =
				action.payload.value
		},
		setAddress: (state, action) => {
			state.persons.find(person => action.payload.id === person.id)!.address = action.payload.value
		},
		setMarried: (state, action) => {
			state.persons.find(person => action.payload.id === person.id)!.married = action.payload.value
		},
		setChildren: (state, action) => {
			state.persons.find(person => action.payload.id === person.id)!.children = action.payload.value
		},
		setMarriageCity: (state, action) => {
			state.persons.find(person => action.payload.id === person.id)!.marriageCity =
				action.payload.value
		},
		setMarriageDate: (state, action) => {
			state.persons.find(person => action.payload.id === person.id)!.marriageDate =
				action.payload.value
		},
		setHasContract: (state, action) => {
			state.persons.find(person => action.payload.id === person.id)!.hasContract =
				action.payload.value
		},
		setContractDate: (state, action) => {
			state.persons.find(person => action.payload.id === person.id)!.contractDate =
				action.payload.value
		},
		setContractPlace: (state, action) => {
			state.persons.find(person => action.payload.id === person.id)!.contractPlace =
				action.payload.value
		},
		setContractType: (state, action) => {
			state.persons.find(person => action.payload.id === person.id)!.contractType =
				action.payload.value
		},
		setIdFile: (state, action) => {
			state.persons.find(person => action.payload.id === person.id)!.idFile = action.payload.value
		},
		setNonFinancingDeclarationFile: (state, action) => {
			state.persons.find(person => action.payload.id === person.id)!.nonFinancingDeclarationFile =
				action.payload.value
		},
	},
})

export const {
	resetPersons,
	addPerson,
	removePerson,
	setGender,
	setLastName,
	setFirstName,
	setPhone,
	setEmail,
	setBirthDate,
	setBirthCity,
	setBirthCountry,
	setNationality,
	setProfession,
	setAddress,
	setMarried,
	setChildren,
	setMarriageCity,
	setMarriageDate,
	setHasContract,
	setContractDate,
	setContractPlace,
	setContractType,
	setIdFile,
	setNonFinancingDeclarationFile,
} = personSlice.actions

export default personSlice.reducer
